import { graphql, useStaticQuery } from "gatsby";
import React, { PropsWithChildren } from "react";
import { Footer } from "../containers/Footer";
import { MainNavigation } from "../containers/MainNavigation";
import { NavigationContextProvider } from "../contexts/NavigationContext";
import { PagesContextProvider } from "../contexts/PagesContext";

const Layout: React.FC<
  PropsWithChildren<{
    corePath: string;
  }>
> = ({ corePath, children }) => {
  const info = useStaticQuery<Queries.LayoutQuery>(graphql`
    query Layout {
      cmsPages: allGraphCmsPage {
        nodes {
          ...DirectPage
        }
      }
    }
  `);

  const cmsPages = info.cmsPages.nodes;
  return (
    <NavigationContextProvider>
      <PagesContextProvider cmsPages={cmsPages}>
        <MainNavigation corePath={corePath} />
        {children}
        <Footer />
      </PagesContextProvider>
    </NavigationContextProvider>
  );
};

export default Layout;
